import React, { useState } from "react";
import styled from "styled-components";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const faqs = [
    {
      question:
        "Est-ce que j'ai un nombre limité de salariés pour beneficier d'une formation subventionnée",
      answer:
        "Oui, dans certains cas, car certains OPCO exigent qu'il y est un nombre determiné pour pouvoir béneficier de la subvention.",
    },
    {
      question:
        "Je suis gérant TNS, est-ce que je peux béneficier d'une formation subventionnée ?",
      answer:
        "Oui, vous pouvez béneficier d'une formation subventionnée par les AGEFICE, les FAFCEA, FIFPL et autres OPCOs dédiés aux TNS",
    },
    {
      question:
        "Qui peut me garantir le rembourcement des frais de formation ?",
      answer:
        "Vous n'avez aucuns frais à débourser. dés la signature de la convention de formation avec l'organisme choisie, vous aurez une confirmation par votre OPCO pour engager la formation et c'est l'organisme de formation qui sera payé directement par l'OPCO",
    },
    {
      question:
        "Je suis réticent à effectuer des formations car ça va occuper mes employés pendant le travail?",
      answer:
        "Vous n'avez pas a vous en soucier car l'OPCO vous rembourse aussi les heures de vos employés passées en formation, c'est pour cela que votre organisme de formation vous demande de présenter les fiches de paie de vos employés",
    },
  ];

  return (
    <FAQContainer>
      {faqs.map((faq, index) => (
        <FAQItem key={index}>
          <FAQQuestion onClick={() => toggleFAQ(index)}>
            {faq.question}
            <i
              className={`fas ${
                activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
              }`}
              style={{ marginLeft: "10px" }}
            ></i>
          </FAQQuestion>
          <FAQAnswer isOpen={activeIndex === index}>{faq.answer}</FAQAnswer>
        </FAQItem>
      ))}
    </FAQContainer>
  );
};

export default FAQSection;

const FAQContainer = styled.div`
  margin: 20px 0;
  padding: 20px;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  max-width: 63%;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const FAQItem = styled.div`
  margin-bottom: 10px;
`;

const FAQQuestion = styled.div`
  padding: 15px;
  background: #225c2e;
  color: #ffffff;
  cursor: pointer;
  border-radius: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FAQAnswer = styled.div`
  padding: 15px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 30px;
  margin-top: 5px;
  display: ${(props) => (props.isOpen ? "block" : "none")};
`;
